import React from 'react';

const FilterButtons = ({ children }) => {
	return <div className="category-subcategory-button">{children}</div>;
};

export default FilterButtons;
